<script setup lang="ts">
const { getResourceUrl } = useResources()
</script>

<template>
  <section class="container">
    <div class="mt-14 flex flex-wrap justify-center px-4">
      <NuxtLink
        :to="getResourceUrl('/assets/front/docs/eu_operacni_program.pdf')"
        target="_blank"
      >
        <img
          :src="getResourceUrl('/assets/front/images/ef_cz.png')"
          class="max-h-96"
          :alt="$t('aboutCompany.eu-support.eu')"
        />
      </NuxtLink>
      <img
        :src="getResourceUrl('/assets/front/images/mpo_cz.jpg')"
        class="mt-4 max-h-80"
        :alt="$t('aboutCompany.eu-support.ministry')"
      />
    </div>
    <div class="my-32"></div>
  </section>
</template>

<style scoped></style>
